import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { TracesPanelProps } from "./TracesPanel";
const TracesPanel = lazy(() => import("./TracesPanel").then((module) => ({ default: module.TracesPanel })));

/** The marks of the story on the storyboard step; a production without marks clears the slot. */
export function mountTracesPanel(projectId: string, props: TracesPanelProps | null) {
  if (!props) return clearStudioView("traces-panel");
  setStudioView("traces-panel", `traces-panel:${projectId}`, <TracesPanel {...props} />);
}
